import { useHasOngoingAcsCall } from "@/common/acs/AcsContext";
import { AgentInteractionStatus } from "@/common/constants/callSession";
import {
	useCallSessionStore,
	CallSessionState,
} from "@/common/stores/nonpersistingStores/callSession";
import {
	useMessagingInviteSessionStore,
	MessagingInviteState,
} from "@/common/stores/nonpersistingStores/messagingInvite";
import { useMemo } from "react";

export const useAgentInteractionState = () => {
	const callSession = useCallSessionStore(
		(state: CallSessionState) => state.callSession
	);

	const messagingInviteSession = useMessagingInviteSessionStore(
		(state: MessagingInviteState) => state.messagingSession
	);

	const hasOngoingAcsCall = useHasOngoingAcsCall();

	// A live ACS call in this client keeps the agent busy whatever the call session holds (none, or a
	// terminated earlier call). Leaving the call (e.g. by a cold transfer) disconnects the agent's ACS leg.
	const agentHasCallInProgressOrTextInOffering = useMemo(
		() =>
			(callSession &&
				callSession?.state !== AgentInteractionStatus.Terminated) ||
			messagingInviteSession?.state === AgentInteractionStatus.Offering ||
			hasOngoingAcsCall,
		[callSession, messagingInviteSession, hasOngoingAcsCall]
	);

	const agentHasInteractionInOffering = useMemo(() => {
		return (
			callSession?.state == AgentInteractionStatus.Offering ||
			callSession?.state ==
				AgentInteractionStatus.ReceivingWarmTransferInvitation ||
			callSession?.state == AgentInteractionStatus.SimultaneousOffering ||
			messagingInviteSession?.state === AgentInteractionStatus.Offering
		);
	}, [callSession, messagingInviteSession]);

	return {
		agentHasCallInProgressOrTextInOffering,
		agentHasInteractionInOffering,
	};
};
